var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var UsageCounter = /** @class */ (function (_super) {
    __extends(UsageCounter, _super);
    function UsageCounter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve a project's usage counter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/usage-counter/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UsageCounter.prototype.find = function (usageCounterId, queryParams) {
        return this.rawFind(Utils.toId(usageCounterId), queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a project's usage counter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/usage-counter/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UsageCounter.prototype.rawFind = function (usageCounterId, queryParams) {
        return this.client.request({
            method: 'GET',
            url: "/usage-log-counters/".concat(usageCounterId),
            queryParams: queryParams,
        });
    };
    UsageCounter.TYPE = 'usage_counter';
    return UsageCounter;
}(BaseResource));
export default UsageCounter;
//# sourceMappingURL=UsageCounter.js.map